import { useRef } from "react";

export default function CameraLight() {
  const directional = useRef();
  return (
    <>
      {/* <spotLight position={[0, 10, 0]} intensity={0.1} /> */}
      <directionalLight
        ref={directional}
        position={[-20, 0, -10]}
        intensity={0.4}
      />
    </>
  );
}
